import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import { BORDER, COLOR_BORDER } from "shared/theme/colors";
import { flex } from "shared/theme/mixins";

export const StyledHeaderContainer = styled(Box)`
  ${flex({ ai: "center" })};
  padding: 0.75rem;
`;

export const StyledItem = styled(Box, {
  shouldForwardProp: (propName) => !["isFirst", "isLast"].includes(propName),
})<{
  isFirst: boolean;
  isLast: boolean;
}>`
  ${flex({ ai: "flex-start" })};
  padding: 0.75rem;
  border-bottom: ${BORDER(1, COLOR_BORDER)};
  ${({ isFirst }) => isFirst && `border-top: ${BORDER(1, COLOR_BORDER)};`}
  ${({ isLast }) => isLast && `border-bottom: none;`}
`;

export const StyledText = styled(Box)`
  ${flex({ ai: "center" })};
`;
